/* eslint-disable no-fallthrough */
import { getToken, getUser } from './auth.js'

var FileDownloader = function(that) {
  this.filesTabNum = function(i) {
    return this._filesTabNum(that, i)
  }
  this.filesTabNumClick = function(i) {
    return this._filesTabNumClick(that, i)
  }
  this.triggerDownload = function(item, idx) {
    return this._triggerDownload(that, item, idx)
  }
  this.regDownloadHandler = function() {
    return this._regDownloadHandler(that)
  }
}

FileDownloader.prototype = {
  _filesTabNum: function(that, i) {
    let fristNum, lastNum
    fristNum = i * that.filesSpace + 1
    lastNum = (i + 1) * that.filesSpace
    if (lastNum > that.filesLength) {
      lastNum = that.filesLength
    }
    var num = (fristNum !== lastNum) ? `${fristNum}-${lastNum}` : `${lastNum}`
    return num
  },
  _filesTabNumClick: function(that, i) {
    let fristNum, lastNum
    fristNum = i * that.filesSpace
    lastNum = (i + 1) * that.filesSpace
    if (lastNum > that.filesLength) {
      lastNum = that.filesLength
    }
    that.tabActive = i
    that.downloadList = that.downloadListArr.slice(fristNum, lastNum)
  },
  _triggerDownload: function(that, item, idx) {
    if (item.downloading) {
      return
    }

    let ua = window.navigator.userAgent.toLowerCase()
    let isUnsupported = [
      'micromessenger', 'iphone', 'ipad', 'ipod'
    ].some(function(unsupported) {
      if (ua.indexOf(unsupported) > -1) {
        return !(unsupported == 'micromessenger' && ua.indexOf('ucweb') > -1)
      }
    })
    if (isUnsupported) {
      alert('您的浏览器不支持文件下载')
      return
    }

    if (getUser()) {
      if (idx == null) {
        idx = that.downloadList.indexOf(item)
      }

      var dnldName = that.movieData.title + item.episode + '.' + item.fmt
      // var dnldWin = window.open('/downloading.html')
      // if (dnldWin) {
      //   window.setTimeout(function() {
      //     dnldWin.postMessage({
      //       itemId: idx,
      //       target: item.file,
      //       saveName: dnldName,
      //       token: getToken()
      //     }, '*')
      //   }, 500)
      // } else {
        var link = document.createElement('a')
        link.style.display = 'none'
        link.href = item.file
        link.download = dnldName
        document.body.appendChild(link)
        if (link.click) {
          link.click()
        } else if (link.dispatchEvent) {
          var evClick = document.createEvent('Event')
          evClick.initEvent('click')
          link.dispatchEvent(evClick)
        }
        document.body.removeChild(link)
        
        this._saveHistory(that, item)
      // }
    } else {
      return new Promise((resolve, reject) => {
        resolve(false)
      })
      // that.$router.go(-1)
    }
  },
  _regDownloadHandler: function(that) {
    if (window.downloadHandler) {
      window.removeEventListener('message', window.downloadHandler)
    }

    var self = this
    window.downloadHandler = function(ev) {
      if (ev.data == null || ev.data.itemId == null) {
        return
      }

      var item = that.downloadList[ev.data.itemId]
      if (item == null || (ev.data.target && ev.data.target != item.file)) {
        return
      }
      switch (ev.data.status) {
        case 'downloading':
          item.downloading = true
          item.percentage = ev.data.percentage
          item.dlstatus = ev.data.progress
          break

        case 'downloaded':
          self._saveHistory(that, item)
          // DON'T break
        case 'cancelled':
          if (ev.data.error) {
            console.log(ev.data.error)
          }
          item.downloading = false
          if (ev.source) {
            ev.source.close()
          }
      }
      that.$set(that.downloadList, ev.data.itemId, item)
    }
    window.addEventListener('message', window.downloadHandler, false)
  },
  _saveHistory: function(that, item) {
    if (window._hmt) {
      window._hmt.push([
        '_trackEvent',
        '视频下载',
        that.movieData.title + item.episode + '.' + item.fmt
      ])
    }
    if (getUser()) {
      var querier = that.$http ? that.$http : that.$axios
      var self = this
      querier({
        url: '/realNet/download/getDownloads',
        method: 'GET',
        params: {
          'videoInfo.id': that.movieId,
          fileId: item.id
        },
        headers: {
          token: getToken()
        }
      }).then(resp => {
        if (
          resp.data.result.content &&
          !self._favorated(resp.data.result.content, that.movieId, item.id)
        ) {
          self._insertHistory(querier, that.movieId, item.id)
        }
      }).catch(error => {
        console.log(error)
      })
    }
  },
  _favorated: function(records, vidId, itemId) {
    let result = false
    for (let i of records) {
      if(i.fileId === itemId && i.videoInfo.id === +vidId) {
        result = true
      }
    }
    return result
  },
  _insertHistory: function(querier, vidId, itemId) {
    querier({
      url: '/realNet/download/insert',
      method: 'POST',
      data: {
        customerId: JSON.parse(getUser()).id,
        videoInfo: { id: vidId },
        fileId: itemId
      },
      headers: {
        token: getToken()
      }
    }).catch(error => {
      console.log(error)
    })
  }
}

export default FileDownloader
